import script from "./TableHeaderData.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderData.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderData.vue?vue&type=style&index=0&id=e587eef8&lang=css"

const __exports__ = script;

export default __exports__